const Util = require('./utils.js');

class MovingObject {
  constructor(options) {
    this.width = options.width;
    this.height = options.height;
    this.color = options.color;
    this.position = options.position;
    this.vel = options.vel;
    this.game = options.game;
  }
}

module.exports = MovingObject;



/*****************
 ** WEBPACK FOOTER
 ** ./game/views/moving_object.js
 ** module id = 7
 ** module chunks = 0
 **/